// docs/116 CI6: when another player raises a toast, a line under the inn's bar says who (the room's
// life layer raises the mugs and plays the chorus). Each cheer is seen once; my own toast coming back
// is not news to me.
import { useEffect, useRef, useState } from 'react';
import { deviceNow } from '../../../../../core/time';
import type { InnCheer } from '../types';
import { myToast } from './InnBar';

const SHOW_MS = 4200;
/** A toast cheer this soon after I raised one is mine coming back. */
const MINE_WINDOW_MS = 4000;

export function ToastLine({ cheers }: { cheers: readonly InnCheer[] }): React.JSX.Element | null {
  const seen = useRef(cheers.reduce((m, c) => Math.max(m, c.n), 0));
  const [line, setLine] = useState<{ n: number; who: string }>();
  useEffect(() => {
    const fresh = cheers.filter((c) => c.n > seen.current);
    if (!fresh.length) return;
    seen.current = Math.max(seen.current, ...fresh.map((c) => c.n));
    for (const c of fresh) {
      if (c.kind !== 'toast') continue;
      if (c.who === 'You' || (myToast.at && deviceNow() - myToast.at < MINE_WINDOW_MS)) { myToast.at = 0; continue; }
      setLine({ n: c.n, who: c.who || 'Someone' });
    }
  }, [cheers]);
  useEffect(() => {
    if (!line) return;
    const t = window.setTimeout(() => setLine(undefined), SHOW_MS);
    return () => window.clearTimeout(t);
  }, [line]);
  if (!line) return null;
  return <div key={line.n} className="fk-innp__toastline" role="status" data-testid="inn-toast-line"><b>{line.who}</b> <i>raises a toast!</i> Mugs go up all round the room.</div>;
}
